var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.show
          ? _c(
              "div",
              { staticClass: "alert", class: "alert-" + _vm.type },
              [
                _vm.type == "success"
                  ? _c("check-circle-icon", {
                      staticClass: "icon",
                      attrs: { icon: "check-circle" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.type == "danger"
                  ? _c("alert-circle-icon", { staticClass: "icon" })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass: "alert-message",
                  domProps: { innerHTML: _vm._s(_vm.message) }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0c93148", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0c93148","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert.vue
// module id = v0WE
// module chunks = 1